import { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { APIContext } from "../../store/APIStore";
import { StoreContext } from "../../store/Store";
import PortalV2Only from "../../components/PortalV2Only/PortalV2Only";

const KioskCenter = () => {
  const api = useContext(APIContext);
  const { eventId } = useParams() as any;
  const [state, dispatch] = useContext(StoreContext);

  useEffect(() => {
    if (eventId && !state.selectedEvent) {
      api.eventService
        .getEvent({ id: eventId })
        .then((event: any) => dispatch({ type: "SET_SELECTED_EVENT", payload: event }))
        .catch(console.log);
    }
  }, []);

  return <PortalV2Only featureName="Kiosk Center" />;
};

export default KioskCenter;
